import { r as require$$0 } from '../../tslib/tslib.es6-BsVGyE_--BlUaNrWd.js';
import { r as requireTypes } from './types-DHzUeLq8-C0BjbYwq.js';

var noParser = {};
(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports._Parser = void 0;
  exports.parse = parse;
  var tslib_1 = require$$0;
  function parse() {
    throw new Error("You're trying to format an uncompiled message with react-intl without parser, please import from 'react-intl' instead");
  }
  tslib_1.__exportStar(requireTypes(), exports);
  exports._Parser = undefined;
})(noParser);

export { noParser as n };
//# sourceMappingURL=no-parser-TpT7P95o-C4j8HRlN.js.map
